import { render, staticRenderFns } from "./standardSpecification.vue?vue&type=template&id=bd185076&scoped=true&"
import script from "./standardSpecification.vue?vue&type=script&lang=js&"
export * from "./standardSpecification.vue?vue&type=script&lang=js&"
import style0 from "./standardSpecification.vue?vue&type=style&index=0&id=bd185076&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd185076",
  null
  
)

export default component.exports